import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import styles from './GraphTabbedWorkspace.module.css';
import style from './tabbar.css'; //for tab styles
import { MdRefresh } from 'react-icons/md';

const Panel = ({ children, value, index }) => {
  if (index !== value) return <div style={{ display: 'none' }} />;
  return <>{children}</>;
};

const GraphTabbedWorkspace = ({ tabs, handleRefreshButtonCLick, setValue }) => {
  const [tabVal, setTabVal] = useState(0);

  const handleTabChange = value => {
    setTabVal(value);
  };

  useEffect(() => {
    setValue(tabVal);
  }, [setValue, tabVal]);

  return (
    <div className={styles.workspace}>
      <div className={styles.tabBar}>
        <Tabs
          value={tabVal}
          onChange={(e, value) => handleTabChange(value)}
          indicatorColor=""
          aria-label="workspace type selection tabs"
          className={styles.tabs}
        >
          {tabs.map(tab => (
            <Tab
              className={styles.tab}
              label={tab.label}
              disabled={tab.disabled}
            />
          ))}
          <button
            className={styles.refreshButton}
            onClick={handleRefreshButtonCLick}
          >
            <MdRefresh className={styles.icRefresh} />
            <span>Refresh</span>
          </button>
        </Tabs>
      </div>

      {tabs.map((tab, index) => (
        <Panel value={tabVal} index={index}>
          <tab.component {...tab.props} />
        </Panel>
      ))}
    </div>
  );
};

export default GraphTabbedWorkspace;
